import {
  StyleSheet,
} from 'react-native';


const styles = StyleSheet.create({
  container_main: {
    flex: 1,
    flexWrap: "wrap",
    marginTop: 8,
    backgroundColor: "#000000",
  },
  container: {
    backgroundColor: "#000000",
  },
  title: {
    fontSize: 30,
    fontWeight: 'bold',
    color: "#ffffff",
    margin: 18
  },
  mtext0: {
    fontSize: 24,
    margin: 3,
    color: "#ffffff"
  },
  mtext1: {
    fontSize: 20,
    margin: 3,
    color: "#ffffff"
  },
  text: {
    fontSize: 25,
    margin: 3,
    color: "#ffffff"
  },

  spaces: {
    margin: 10,
    paddingRight: 20,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },

  table: {
    backgroundColor: "#000000",
    flex: 1,
    flexDirection: "column",
    borderWidth: 4,
    borderColor: "#444444",
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: "auto",
  },
  tableRow: {
    backgroundColor: "transparent",
    flexWrap: 'wrap',
    flexDirection: "row",
  },
  tableRowFlex: {
    flexDirection: "row",
    flexWrap: 'wrap',

  },
  tableCol: {
    flexDirection: "column",
  },
  tableColumnRegular0: {
    backgroundColor: "#000000",
    color: "#ffffff",
    width: "100%",
    alignItems: "baseline",
    padding: 2,
  },
  tableColumnRegular1: {
    color: "#ffffff",
    width: "70%",
    alignItems: "baseline",
    padding: 2,
  },
  tableColumnRegular2: {
    color: "#ffffff",
    width: "30%",
    alignItems: "baseline",
    padding: 2,
  },
  tableColumnRegular2_colored: {
    color: "#ffffff",
    backgroundColor: "#990000",
    width: "30%",
    alignItems: "baseline",
    padding: 2,
  },


});


export default styles;